import * as api from "../api/registrationApi";
import * as types from "../constants/ActionTypes";

import { FormattedMessage } from "react-intl";
import React from "react";
import queryString from "query-string";
import { showNotification } from "./notificationsActions";
import { useToken } from "./recaptchaActions";

const validProfileName = name => typeof name === "string" && name.length > 0;

export const fetchRegistration = () => async dispatch => {
  const profileName = queryString.parse(window.location.search).name;
  const isValid = validProfileName(profileName);
  let data;
  let errorMessage;
  try {
    data = isValid ? await api.fetchIndex(profileName) : undefined;
  } catch (err) {
    try {
      const response = err.response && (await err.response.json());
      errorMessage = response && response.message;
    } catch (_parseError) {}
  }

  dispatch({
    type: types.REGISTRATION_DATA_LOADED,
    profileName: isValid ? profileName : undefined,
    data,
    errorMessage
  });
};

export const register = ({
  name,
  grecaptchaToken,
  email,
  firstname,
  lastname,
  customValueFields
}) => async dispatch => {
  try {
    const resp_json = await api.register({
      name,
      grecaptchaToken,
      email,
      firstname,
      lastname,
      customValueFields
    });

    dispatch(registrationSucceeded(resp_json));
  } catch (err) {
    const response = err.response && (await err.response.json());
    const errorMessages = (response && response.errors) || [
      <FormattedMessage
        id="genericError"
        defaultMessage="An unexpected error occurred and our engineering team has been notified. Please try again in a few moments."
      />
    ];
    for (let message of errorMessages) {
      if (message === "EMAIL_COLLISION") {
        // Email collision still sends an email, so it's counted as success
        dispatch(registrationSucceeded({}));
      } else {
        dispatch(
          showNotification({
            message,
            notificationType: "error",
            dismissDelay: 3000
          })
        );
      }
    }
  } finally {
    // Invalidate token afterwards, regardless of response
    dispatch(useToken());
  }
};

const registrationSucceeded = (obj) => ({
  type: types.REGISTRATION_SUCCEEDED,
  registration_type: obj.type,
  registration_data: obj  
});
